export default "__VITE_PUBLIC_ASSET__13b315ad__"